module.exports = __webpack_public_path__ + "static/media/rapunzel-win.5dff589c.png";